export default __webpack_public_path__ + "bf19dd8e1e4e09987ed49b004f2a2582.jpg";